
var styles = require("../styles/main");

require("./index");



/** WEBPACK FOOTER **
 ** ./src/scripts/index-with-styles.js
 **/